const WINDOWS_REGEX = /Win/;
const MACOS_REGEX = /Mac/;
const CHROMEBOOK_REGEX = /Chromebook/;

const isIpadIos13 = navigator.userAgent.toLowerCase().indexOf('macintosh') > -1 && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
const IS_CHROMEBOOK = ((CHROMEBOOK_REGEX.exec(navigator.userAgent) !== null) || (navigator.userAgent.indexOf('CrOS') !== -1 && navigator.platform.indexOf('Linux') !== -1)); // eslint-disable-line
const IS_WINDOWS = ((WINDOWS_REGEX.exec(navigator.platform) !== null));
const IS_MAC = (MACOS_REGEX.exec(navigator.platform) !== null);
const IS_DESKTOP = ((IS_WINDOWS || IS_MAC || IS_CHROMEBOOK) && !isIpadIos13);

export {
  IS_CHROMEBOOK,
  IS_DESKTOP,
  IS_MAC,
  IS_WINDOWS
};

